const ServicePriceTypeEnum = Object.freeze({
    PER_PERSON: 'per-person',
    PER_UNIT: 'per-unit',
    PER_DAY_PER_PERSON: 'per-day-per-person',
    PER_NIGHT_PER_PERSON: 'per-night-per-person',
    PER_DAY_PER_UNIT: 'per-day-per-unit',
});

const ServicePriceTypeEnumMap = Object.freeze({
    [ServicePriceTypeEnum.PER_PERSON]: { name: 'Per person' },
    [ServicePriceTypeEnum.PER_UNIT]: { name: 'Per unit' },
    [ServicePriceTypeEnum.PER_DAY_PER_PERSON]: { name: 'Per day / per person' },
    [ServicePriceTypeEnum.PER_NIGHT_PER_PERSON]: { name: 'Per night / per person' },
    [ServicePriceTypeEnum.PER_DAY_PER_UNIT]: { name: 'Per day / per unit' },
});

function priceTypeEnumMap(priceType) {
    return ServicePriceTypeEnumMap[priceType];
}

function isPerPersonBased(service) {
    return [
        ServicePriceTypeEnum.PER_PERSON,
        ServicePriceTypeEnum.PER_NIGHT_PER_PERSON,
        ServicePriceTypeEnum.PER_DAY_PER_PERSON,
    ].includes(service.price_type);
}

function isHiddenQuantity(service) {
    return [ServicePriceTypeEnum.PER_DAY_PER_PERSON].includes(service.price_type);
}

export const ServicePriceType = {
    priceTypeEnumMap,
    isPerPersonBased,
    isHiddenQuantity,
    methods: {
        priceTypeEnumMap(priceType) {
            return priceTypeEnumMap(priceType);
        },
        isPerPersonBased(service) {
            return isPerPersonBased(service);
        },
        isHiddenQuantity(service) {
            return isHiddenQuantity(service);
        },
        serviceUnits(service) {
            return isPerPersonBased(service) ? this.$t('pax') : this.$t('pcs');
        },
    },
};

const CategoryTypeEnum = Object.freeze({
    SINGLE_CHOICE: 'single-choice',
    MULTIPLE_CHOICE: 'multiple-choice',
    SINGLE_COUNTER: 'single-counter',
    MULTIPLE_COUNTER: 'multiple-counter',
});

function isSingleChoice(category) {
    return [CategoryTypeEnum.SINGLE_COUNTER, CategoryTypeEnum.SINGLE_CHOICE].includes(category.type);
}

function isMultipleChoice(category) {
    return category.type === CategoryTypeEnum.MULTIPLE_CHOICE;
}

function isCheckable(category) {
    return [
        CategoryTypeEnum.SINGLE_CHOICE,
        CategoryTypeEnum.MULTIPLE_CHOICE,
        CategoryTypeEnum.MULTIPLE_COUNTER,
    ].includes(category.type);
}

function isCounter(category) {
    return [CategoryTypeEnum.MULTIPLE_COUNTER].includes(category.type);
}

export const CategoryType = {
    isSingleChoice,
    isMultipleChoice,
    isCheckable,
    isCounter,
};

export const CategoryTypeMixin = {
    methods: {
        isSingleChoice(category) {
            return isSingleChoice(category);
        },
        isMultipleChoice(category) {
            return isMultipleChoice(category);
        },
        isCheckable(category) {
            return isCheckable(category);
        },
        isCounter(category) {
            return isCounter(category);
        },
    },
};

const CategoryShowAsEnum = Object.freeze({
    IMAGES: 'images',
    TEXT: 'text',
    TEXT_WITH_DESCRIPTION: 'text-with-description',
    ICONS: 'icons',
    COUNTER: 'counter',
    COUNTER_WITH_DESCRIPTION: 'counter-with-description',
});

function showAsImages(category) {
    return category.show_as === CategoryShowAsEnum.IMAGES;
}

function showAsText(category) {
    return category.show_as === CategoryShowAsEnum.TEXT;
}

function showAsTextWithDescription(category) {
    return category.show_as === CategoryShowAsEnum.TEXT_WITH_DESCRIPTION;
}

function showAsIcons(category) {
    return category.show_as === CategoryShowAsEnum.ICONS;
}

function showAsCounter(category) {
    return category.show_as === CategoryShowAsEnum.COUNTER;
}

function showAsCounterWithDescription(category) {
    return category.show_as === CategoryShowAsEnum.COUNTER_WITH_DESCRIPTION;
}

export const CategoryShowAs = {
    showAsText,
    showAsIcons,
    showAsImages,
    showAsCounter,
    showAsTextWithDescription,
};

export const CategoryShowAsMixin = {
    methods: {
        showAsText(category) {
            return showAsText(category);
        },
        showAsIcons(category) {
            return showAsIcons(category);
        },
        showAsImages(category) {
            return showAsImages(category);
        },
        showAsCounter(category) {
            return showAsCounter(category);
        },
        showAsTextWithDescription(category) {
            return showAsTextWithDescription(category);
        },
        showAsCounterWithDescription(category) {
            return showAsCounterWithDescription(category);
        },
    },
};

export const CategoryShowAsMixinComputed = {
    computed: {
        CategoryShowAs() {
            return {
                showAsText,
                showAsIcons,
                showAsImages,
                showAsCounter,
            };
        },
    },
};
